export default __webpack_public_path__ + "static/media/UA.e9ff8239.svg";